import React, { useState } from 'react';

import { ErrorRetrievingData } from '../../components/ErrorRetrievingData';

import { FormPropriedade } from '../../components/FormPropriedade';
import MenuMain from '../../MenuMain';
import { AppFooter } from '../../AppFooter';

export default function CadastrarBairrosPage() {

  const [isLoading, setIsLoading] = useState(false);
  const [errorRetrievingData, setErrorRetrievingData] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const defaultValues = {
    "id": 0,
    "nome": "",
    "endereco": "",
    "numero": "",
    "complemento": "",
    "cep": "",
    "municipioNome": "",
    "municipioId":0,
    "areaTotal": 0,
    "areaExplorada": 0,
    "areaCultivada": 0,
    "geoLocalizacao": "0,0",
    "pronaf": false,
    "tipoPosse": "",
    "proprietarioNome": "",
    "proprietarioId":0
  }
  
  return (
    <>
      <MenuMain>
        {
          errorRetrievingData ?
            <ErrorRetrievingData
              errorMessage={errorMessage}
              isLoading={isLoading}
            />
            :
              <FormPropriedade
                defaultValues={defaultValues}
                isLoading={isLoading}                
                isEditing={false}
              />
        }
      </MenuMain>
      <AppFooter />
    </>
  );
}
